import React from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive, VStack } from '@garnish/core';

import { CreditOverviewBalance } from './CreditOverviewBalance';
import { CreditOverviewPromoCodeForm } from './CreditOverviewPromoCodeForm';

import type { CreditSectionProps } from '../CreditSectionProps';

export const CreditOverview = (props: CreditSectionProps) => {
  const { currentBreakpoint } = useResponsive();

  return (
    <VStack
      gap={0}
      hasDivider={currentBreakpoint.isXS}
      dividerColor={theme.colors.LIGHT}
      style={!currentBreakpoint.isXS && styles.container}
    >
      <CreditOverviewBalance {...props} />
      <CreditOverviewPromoCodeForm {...props} />
    </VStack>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
    justifyContent: 'center',
  },
});
